export default {
  主页面标题: "Purchase Request Management",
  申请采购按钮: "Apply for Purchase",
  草稿: "Draft",
  审批中: "Under Review",
  已驳回: "Rejected",
  已通过: "Approved",
  采购申请状态: "Purchase Request Status",
  表单编号: "Form Number",
  PR编号: "PR Number",
  物料: "Material",
  供应商: "Supplier",
  申请表类型: "Application Type",
  采购类别: "Purchase Category",
  工厂: "Factory",
  二级采购类别: "Secondary Purchase Category",
  三级采购类别: "Tertiary Purchase Category",
  采购负责人: "Purchase Responsible Person",
  PO编号: "PO Number",
  采购项数: "Number of Items",
  物料类别: "Material Category",
  物料编号: "Material Code",
  物料名称: "Material Name",
  产品名称: "Product Name",
  采购申请总金额HKD: "Total Amount (HKD)",
  要求完成日期: "Required Completion Date",
  要求到货日期: "Required Delivery Date",
  申请人: "Applicant",
  申请时间: "Application Time",
  操作: "Action",
  搜索物料编号名称占位符: "Enter material code/name",
  搜索供应商编号名称占位符: "Enter supplier code/name",
  编辑: "Edit",
  查看: "View",
  重新提交: "Resubmit",
  删除: "Delete",
  采购申请表: "Purchase Application Form",
  下一步: "Next",
  采购类型: "Purchase Type",
  是否有物料编号: "Has Material Code",
  申请信息: "Application Information",
  请选择: "Please select",
  请选择申请部门: "Please select application department",
  暂存: "Save as Draft",
  提交: "Submit",
  关闭: "Close",
  提交成功: "Submitted successfully",
  请检查表单填写是否完整: "Please check if the form is complete",
  请先生成PR编号: "Please generate PR number first",
  订单确认: "Order Confirmation",
  审批通过: "Approved",
  表单类型信息缺失无法执行审批: "Form type information missing, cannot approve",
  未配置采购人员审核策略:
    "No purchaser review strategy configured for this form type, cannot approve",
  未配置财务人员初审策略:
    "No finance initial review strategy configured for this form type, cannot approve",
  请完善寻源结果: "Please complete sourcing results",
  生成PR: "Generate PR",
  确认: "Confirm",
  确认生成PR编号吗: "Confirm to generate PR number?",
  寻源结果: "Sourcing Results",
  申请采购物品明细: "Purchase Items Details",
  采购组: "Purchasing Group",
  是否指定建议供应商: "Specify/Recommend Supplier",
  指定建议供应商名称: "Supplier Name",
  指定建议供应商原因: "Reason for Specification",
  是否需要合同: "Contract Required",
  指定建议供应商相关附件: "Related Attachments",
  寻源结果说明: "Sourcing Notes",
  合同文件: "Contract File",
  供应商编号: "Supplier Code",
  供应商名称: "Supplier Name",
  报价单: "Quotation",
  继续添加: "Continue Adding",
  请输入供应商名称: "Enter supplier name",
  获取物料: "Get Materials",
  序号: "No.",
  添加: "Add",
  分类: "Category",
  申请数量: "Quantity",
  单位: "Unit",
  每组单位: "Unit per Group",
  单价HKD: "Unit Price HKD",
  年采购均价: "Annual Average Price",
  申请总金额HKD: "Total Amount HKD",
  采购说明: "Purchase Notes",
  采购原因: "Purchase Reason",
  安全库存: "Safety Stock",
  优先采购: "Priority Purchase",
  上传附件: "Upload Attachment",
  固定资产信息: "Fixed Asset Information",
  是否创建固定资产编号: "Create Fixed Asset Code",
  固定资产编号: "Fixed Asset Code",
  预算信息: "Budget Information",
  申请人提供文件: "Applicant Provided Documents",
  已批准预算类型: "Approved Budget Type",
  项目编号: "Project Code",
  原因说明: "Reason Description",
  预算金额币种: "Budget Amount/Currency",
  预算金额HKD: "Budget Amount HKD",
  申请总金额币种: "Application Amount/Currency",
  采购委员会会议纪要文件: "Procurement Committee Meeting Minutes",
  计划书URS配置清单第一次报价等文件: "Plan/URS/Config List/First Quote",
  实地考察报告用户要求符合度评估文件:
    "Site Visit Report/User Requirement Compliance",
  供应商比较总结商务标评分表: "Supplier Comparison/Business Score Sheet",
  合并评分表: "Combined Score Sheet",
  投资分析: "Investment Analysis",
  特别要求: "Special Requirements",
  是否现有生产物料: "Existing Production Material",
  相关产品名称: "Related Product Name",
  关联项目编号: "Linked Project Code",
  关联项目名称: "Linked Project Name",
  供应商信息: "Supplier Information",
  数量单位: "Quantity/Unit",
  单价币种: "Unit Price/Currency",
  总价币种: "Total Price/Currency",
  备注: "Remarks",
  药典标准: "Pharmacopoeia/Standard",
  指定建议的药典或质量标准如有: "Specified/Recommended Pharmacopoeia",
  批次要求: "Batch Requirements",
  是否指定供应商: "Specify Supplier",
  指定建议供应商COA: "Supplier COA",
  其他附件: "Other Attachments",
  RLD中文通用名称: "RLD Chinese Generic Name",
  RLD英文通用名称: "RLD English Generic Name",
  RLD中文商品名称: "RLD Chinese Brand Name",
  RLD英文商品名称: "RLD English Brand Name",
  请附上指定建议的RLD说明资料: "Attach RLD Specification Documents",
  上市国家或地区: "Country/Region of Listing",
  主要成分: "Active Ingredients",
  规格: "Specification",
  剂型: "Dosage Form",
  包装规格: "Pack Size",
  需求数量: "Required Quantity",
  要求到货时间: "Required Delivery Time",
  效期要求: "Shelf Life Requirements",
  从供应商库选择: "Select from Supplier Database",
  搜索物料: "Search Material",
  单价: "Unit Price",
  单价单位: "Price Unit",
  费用归属部门: "Cost Center Department",
  成本中心: "Cost Center",
  会计科目: "Accounting Subject",
  物料组: "Material Group",
  期望到货日期: "Expected Delivery Date",
  是否紧急采购: "Urgent Purchase",
  单一: "Single",
  多个: "Multiple",
  指定供应商及型号: "Specified Supplier and Model",
  指定原因: "Reason for Specification",
  采购物品描述: "Purchase Item Description",
  采购目的: "Purchase Purpose",
  请选择物料: "Please select material",
  请输入申请数量: "Enter quantity",
  请选择单位: "Please select unit",
  请选择物料组: "Please select material group",
  请选择日期: "Please select date",
  请输入描述: "Enter description",
  请选择成本中心: "Please select cost center",
  请选择币种: "Please select currency",
  请选择采购组: "Please select purchasing group",
  请输入关联项目编号: "Enter project code",
  请输入关联项目名称: "Enter project name",
  请选择供应商: "Please select supplier",
  二级物料类别: "Secondary Material Category",
  申请金额范围: "Application Amount Range",
  自动计算: "Auto Calculate",
  总金额: "Total Amount",
  请输入固定资产编号: "Enter fixed asset code",
  请输入寻源结果: "Enter sourcing result",
  请输入包装规格: "Enter pack size",
  请输入预算金额: "Enter budget amount",
  请输入申请总金额: "Enter total application amount",
  请选择是否指定建议供应商: "Please select if specify/recommend supplier",
  最后PO单价: "Last PO Unit Price",
  新旧价格变动: "New/Old Price Change",
  最后PO供应商编号: "Last PO Supplier Code",
  最后PO供应商名称: "Last PO Supplier Name",
  最后PO币种: "Last PO Currency",
  上次PO价格数量单位: "Last PO Price Qty Unit",
  最后PO数量: "Last PO Qty",
  现有库存: "Current Stock",
  描述: "Description",
  请选择是否现有生产物料: "Please select if existing production material",
  请选择要求完成日期: "Please select required completion date",
  请选择费用归属部门: "Please select cost attribution department",
  请选择会计科目: "Please select accounting subject",
  请选择是否紧急采购: "Please select if urgent procurement",
};
